import React from "react";
import SelectField from "../SelectField";

type Props = {
  id?: string;
  label: string;
  /** JSON-encoded string array, or "" when nothing is selected. */
  value: string;
  options: readonly string[] | string[];
  searchable?: boolean;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  errorText?: string;
  optionSearchKeys?: Record<string, string[]>;
  optionLabelMap?: Record<string, string>;
  activeDropdownId?: string | null;
  onDropdownToggle?: (id: string | null) => void;
  onBlur?: () => void;
  onChange: (value: string) => void;
};

const MultiSelectFieldTemplate: React.FC<Props> = (props) => {
  return <SelectField {...props} multiSelect />;
};

export default MultiSelectFieldTemplate;
